import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Star, Gift, Package } from "lucide-react";
import api from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const imgUrl = (u) => (u ? `${BACKEND}${u}` : null);

export default function PlusCatalog() {
  const navigate = useNavigate();
  const [rewards, setRewards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/plus/rewards")
      .then((r) => setRewards(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      <div className="max-w-5xl mx-auto px-6 py-8">
        <button data-testid="plus-catalog-back" onClick={() => navigate("/")}
          className="flex items-center gap-2 text-zinc-400 hover:text-white mb-6 transition-colors">
          <ArrowLeft className="w-5 h-5" /> Home
        </button>

        <div className="flex items-center gap-3 mb-2">
          <Gift className="w-7 h-7 text-amber-400" />
          <h1 className="font-display text-3xl font-bold">Catalogo Premi</h1>
        </div>
        <p className="text-zinc-500 mb-8">Riscatta i premi con i Punti Stella. Il riscatto si effettua dalla scheda cliente.</p>

        {loading ? (
          <p className="text-zinc-500">Caricamento…</p>
        ) : rewards.length === 0 ? (
          <div className="rounded-3xl bg-zinc-900 border border-dashed border-zinc-700 p-10 text-center">
            <Package className="w-10 h-10 text-zinc-600 mx-auto mb-3" />
            <p className="text-zinc-400">Nessun premio disponibile al momento.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="plus-catalog-grid">
            {rewards.map((r) => (
              <div key={r.id} data-testid={`plus-catalog-item-${r.id}`}
                className="rounded-2xl bg-zinc-900 border border-zinc-800 overflow-hidden flex flex-col">
                <div className="aspect-[4/3] bg-zinc-800 flex items-center justify-center overflow-hidden">
                  {r.image_url
                    ? <img src={imgUrl(r.image_url)} alt={r.nome} className="w-full h-full object-cover" />
                    : <Gift className="w-12 h-12 text-zinc-700" />}
                </div>
                <div className="p-4 flex flex-col flex-1">
                  <h3 className="font-display font-bold text-lg">{r.nome}</h3>
                  {r.descrizione && <p className="text-zinc-500 text-sm mt-1 flex-1">{r.descrizione}</p>}
                  <div className="flex items-center justify-between mt-3">
                    <span className="inline-flex items-center gap-1.5 text-amber-400 font-bold">
                      <Star className="w-4 h-4 fill-current" /> {r.points_required}
                    </span>
                    {r.stock_tracking && (
                      <span className={`text-xs px-2 py-0.5 rounded-full ${r.stock_quantity > 0 ? "bg-zinc-800 text-zinc-400" : "bg-red-500/15 text-red-400"}`}>
                        {r.stock_quantity > 0 ? `${r.stock_quantity} disp.` : "Esaurito"}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
